import type { ReactNode } from 'react'
import '../style/components/Popup.css'

type PopupProps = {
  open: boolean
  title?: string
  titleNode?: ReactNode
  children?: ReactNode
  onClose: () => void
  showClose?: boolean
  closeOnBackdrop?: boolean
  coverBackground?: boolean
  gradientBackground?: boolean
  windowClassName?: string
  bodyClassName?: string
}

function Popup({
  open,
  title,
  titleNode,
  children,
  onClose,
  showClose = true,
  closeOnBackdrop = true,
  coverBackground = true,
  gradientBackground = true,
  windowClassName,
  bodyClassName,
}: PopupProps) {
  if (!open) return null

  return (
    <div
      className={`popup-backdrop ${coverBackground ? '' : 'no-blur'}`.trim()}
      onClick={closeOnBackdrop ? onClose : undefined}
    >
      <div
        className={`popup-window ${gradientBackground ? '' : 'no-gradient'} ${windowClassName || ''}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label={title ?? 'Popup window'}
        onClick={(event) => event.stopPropagation()}
      >
        {showClose && (
          <button type="button" className="popup-close" onClick={onClose} aria-label="Close popup">
            <span aria-hidden="true">&times;</span>
          </button>
        )}
        {(titleNode || title) && <h2 className="popup-title">{titleNode || title}</h2>}
        {children && <div className={`popup-body ${bodyClassName || ''}`.trim()}>{children}</div>}
      </div>
    </div>
  )
}

export default Popup
